import { makeStyles } from "@material-ui/core/styles";
import { BASE_COLORS, FONT_SIZES } from "../../../../emotion-theme";

export const useGreenButtonStyle = makeStyles(() => ({
  button: {
    justifyContent: "center",
    padding: "1rem 2rem",
    minWidth: "100px",
    fontWeight: "bold",
    fontSize: FONT_SIZES.large,
    color: BASE_COLORS.lynxWhite,
    backgroundColor: BASE_COLORS.treeGreen,
    cursor: "pointer",
  },
  disabled: {
    color: BASE_COLORS.lightGrey,
    backgroundColor: BASE_COLORS.lynxWhite,
    cursor: "default",
  },
  marginAround: {
    margin: "0 1.25rem 0",
  },
}));
